<template>
  <div v-if="$store.state.previouslyViewed.length">
    <Title :title="translations.previousViewed" />
    <div v-for="product in $store.state.previouslyViewed" :key="`previous_view_${product.id}`">
      <router-link class="previous-viewed" :to="product.permalink">
        <Gallery
          :thumbnail="product.thumbnail"
          :displayImages="false"
          :displayType="'thumbnail'"
          :images="[]"
          :canOpen="false"
        />
        <div class="previous-viewed__content">
          <p>{{ product.name }}</p>
          <Price
            v-if="!product.isVariable"
            :regularPrice="product.regular_price"
            :salePrice="product.sale_price"
          />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Price from "@/layouts/general-ui/Price.vue";
import Gallery from "@/layouts/general-ui/Gallery.vue";
import Title from "@/layouts/general-ui/Title.vue";

export default {
  name: "PreviousViews",
  components: {
    Price,
    Gallery,
    Title
  },
  data() {
    return {
      translations: {
        previousViewed: ws_vue_store.translations.previous_viewed
      }
    };
  },
  props: {
    amountToDisplay: Number,
    title: String
  }
};
</script>

<style lang="scss" scoped>
.previous-viewed {
  display: grid;
  grid-template-columns: 0.4fr 0.6fr;
  gap: 1rem;
  margin-bottom: 1rem;
  text-decoration: none;

  &__content {
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
  }
}
</style>
